(() => {
 const setup = () => {
  document.querySelectorAll('.ks-series-head').forEach(head => {
   if (head.dataset.ksReady) return;
   head.dataset.ksReady = 'true';
   const product = head.querySelector('ks-product');
   const axes = head.querySelector('[data-ks-bundle-axes]');
   const variants = axes ? JSON.parse(axes.querySelector('[data-ks-bundle-variants]').textContent) : [];
   const groups = axes ? [...axes.querySelectorAll('[data-ks-option-index]')] : [];
   const current = () => variants.find(v => String(v.id) === product.querySelector('[data-ks-variant-input]').value);
   const updateContents = variant => {
    head.querySelectorAll('[data-ks-bundle-panel]').forEach(panel => panel.hidden = !variant.title.includes(panel.dataset.ksBundlePanel));
    ['adb-contents__only_main','adb-contents__only_ext'].forEach(id => {const node = head.querySelector('#' + id);if (node) node.textContent = variant.title;});
    const tag = head.querySelector('#adb-contents-tag');if (tag) tag.textContent = variant.title + ' Bundle';
   };
   const sync = () => {
    const variant = current();if (!variant) return;
    groups.forEach((group,index) => group.querySelectorAll('[data-ks-option-value]').forEach(button => {
     const value = button.dataset.ksOptionValue;
     button.setAttribute('aria-pressed',String(value === variant.options[index]));
     const match = variants.find(v => v.options.every((option,i) => option === (i === index ? value : variant.options[i])));
     const status = button.querySelector('[data-ks-choice-status]');
     status.textContent = match ? (match.available ? '' : product.data.strings.soldOut) : 'Unavailable';
     button.disabled = !match;
     button.dataset.soldOut = String(!!match && !match.available);
    }));
   };
   if (axes) {
    axes.addEventListener('click',event => {
     const button = event.target.closest('[data-ks-option-value]');
     if (!button || button.disabled || button.hidden) return;
     const options = current()?.options.slice();if (!options) return;
     const index = Number(button.closest('[data-ks-option-index]').dataset.ksOptionIndex);
     options[index] = button.dataset.ksOptionValue;
     const variant = variants.find(v => v.options.every((value,i) => value === options[i]));
     if (variant) product.selectVariant(variant.id,true);
    });
    const market = () => {
     if (axes.dataset.handle !== 'barbarian-bundle') return;
     const currency = window.Shopify?.currency?.active || axes.dataset.currency;
     groups[0].querySelectorAll('[data-ks-option-value]').forEach(button => {
      const value = button.dataset.ksOptionValue.toLowerCase();
      button.hidden = value.includes('lb') ? !['USD','CAD'].includes(currency) : value.includes('kg') ? currency === 'USD' : false;
     });
     const selected = groups[0].querySelector('[aria-pressed="true"]');
     if (selected?.hidden) {
      const v = current();
      const fallback = variants.find(other => /no weights/i.test(other.options[0]) && other.options[1] === v?.options[1]);
      if (fallback) product.selectVariant(fallback.id,true);
     }
    };
    market();
    document.addEventListener('currency:changed',market);
    document.addEventListener('currency:change',market);
    sync();
   }
   product.addEventListener('variant:change',event => {sync();updateContents(event.detail.variant);});
   if (product.variant) updateContents(product.variant);
  });
  document.querySelectorAll('.ks-series-story .t10-act').forEach(button => {
   if (button.dataset.ksReady) return;button.dataset.ksReady = 'true';
   button.setAttribute('aria-expanded',String(button.parentElement.classList.contains('open')));
   button.addEventListener('click',() => button.setAttribute('aria-expanded',String(button.parentElement.classList.toggle('open'))));
  });
  document.querySelectorAll('.ks-series-story [data-ks-back-to-product],.ks-series-story a[href="#"],.ks-series-story a[href="#top"]').forEach(button => {
   if (button.dataset.ksReady) return;button.dataset.ksReady = 'true';
   button.addEventListener('click',event => {event.preventDefault();document.querySelector('.ks-series-head')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});});
  });
 };
 customElements.whenDefined('ks-product').then(setup);
 document.addEventListener('shopify:section:load',setup);
})();
